import { P2GAlert, P2GBox, P2GButton, P2GGrid, P2GText, useP2GMediaQueryOnly } from '@parcel2go/core-ui';
import { ReactNode, useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { BasketItem, BasketMeta } from '~/lib/types/basket-types';
import { BasketSections } from '~/lib/types/enums';

export type props = {
  wrapper: (x: ReactNode) => ReactNode;
  items: { name: string; item: BasketItem }[];
  onEdit: (id: string) => void;
  onClear: () => void;
};

const hasOutStanding = (item: BasketItem) => (item.sections[BasketSections.META]?.payload as BasketMeta)?.staging;

export default function Outstanding({ wrapper, items, onEdit, onClear }: props) {
  const { t } = useTranslation(TranslationNamespaces.CHECKOUT);
  const isXs = useP2GMediaQueryOnly('xs');
  const activeCount = useMemo(() => items.filter((x) => hasOutStanding(x.item)).length, [items]);
  const active = useMemo(() => items.find((x) => hasOutStanding(x.item)), [items]);
  if (active) {
    return wrapper(
      <P2GAlert type="warning">
        <P2GGrid container gap={2} direction="column">
          <P2GGrid item>
            <P2GText fontWeight="bold" component="p">
              <Trans
                i18nKey="BASKET_SPLIT_OUTSTANDING_TITLE"
                t={t}
                defaults="Click ‘Continue’ to add your additional {{count}} parcels."
                values={{ count: activeCount }}
              />
            </P2GText>
            <P2GText component="p">
              <Trans
                i18nKey="BASKET_SPLIT_OUTSTANDING_SUBTITLE"
                t={t}
                defaults="Or choose ‘Cancel/Clear’ to remove these parcels."
                values={{ count: activeCount }}
              />
            </P2GText>
          </P2GGrid>
          <P2GGrid item>
            <P2GBox display="flex" gap={2}>
              <P2GButton onClick={() => onEdit(active.name)}>
                {t('BASKET_SPLIT_OUTSTANDING_CONTINUE_BUTTON', { defaultValue: 'Continue' })}
              </P2GButton>
              <P2GButton onClick={onClear} variant="tertiary">
                {t('BASKET_SPLIT_OUTSTANDING_CANCEL_BUTTON', { defaultValue: isXs ? 'Cancel' : 'Cancel / Clear' })}
              </P2GButton>
            </P2GBox>
          </P2GGrid>
        </P2GGrid>
      </P2GAlert>
    );
  }

  return null;
}
